import { NO_RETRY_CODE } from './constants';

export const isSkipRetry = (status?: string | number) => NO_RETRY_CODE.includes(parseInt(String(status), 10));
